module.exports = __webpack_public_path__ + "static/media/stand_by.605600e7.svg";